var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "segmented-control", style: [_vm.segmentedControlStyle] },
    _vm._l(_vm.options, function (option) {
      return _c(
        "div",
        {
          staticClass: "segmented-item",
          class: {
            "is-selected": _vm.valuesSelected.includes(option[_vm.value]),
          },
          style: [
            _vm.valuesSelected.includes(option[_vm.value])
              ? _vm.itemSelectedStyle
              : null,
            _vm.itemStyle,
          ],
          on: {
            click: function ($event) {
              return _vm.onSelect(option)
            },
          },
        },
        [_vm._v("\n        " + _vm._s(option[_vm.label]) + "\n    ")]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }